export default {
  data () {
    return {
      corporationTypes: [
        { value: '01', text: '株式会社' },
        { value: '02', text: '有限会社' },
        { value: '999', text: '個人事業主（屋号で登録）' },
        { value: '00', text: '個人事業主（氏名で登録）' },
        { value: '05', text: '医療法人' },
        { value: '22', text: '医療法人社団' },
        { value: '28', text: '医療法人財団' },
        { value: '31', text: '社会医療法人' },
        { value: '10', text: '社会福祉法人' },
        { value: '24', text: '公益社団法人' },
        { value: '25', text: '公益財団法人' },
        { value: '26', text: '一般社団法人' },
        { value: '27', text: '一般財団法人' },
        { value: '16', text: '特定非営利活動法人' },
        { value: '29', text: '協同組合' },
        { value: '30', text: '合同会社' },
        { value: '03', text: '合名会社' },
        { value: '04', text: '合資会社' },
        { value: '11', text: '相互会社' },
        { value: '23', text: '公共機関' },
        { value: '18', text: '独立行政法人' },
        { value: '32', text: '地方独立行政法人' },
        { value: '09', text: '学校法人' },
        { value: '15', text: '国立大学法人' },
        { value: '33', text: '公立大学法人' },
        { value: '08', text: '宗教法人' },
        { value: '12', text: '行政書士法人' },
        { value: '13', text: '司法書士法人' },
        { value: '14', text: '税理士法人' },
        { value: '19', text: '弁護士法人' },
        { value: '17', text: '更生保護法人' },
        { value: '20', text: '有限責任中間法人' },
        { value: '21', text: '無限責任中間法人' },
        { value: '99', text: 'その他（上記以外）' },
      ]
    }
  },
  methods: {
    /**
     *
     * @param val
     * @return {{value: string, text: string}}
     */
    corporationTypeBy (val) {
      return this.corporationTypes.find(({ value }) => value === val);
    }
  }
}
